/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ProjectCustomerProjectCustomerById } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * ProjectsFromCustomerByIdApi - axios parameter creator
 * @export
 */
export const ProjectsFromCustomerByIdApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get details of a specific project attached to a customer by its ID
         * @param {string} storeId The store identifier.
         * @param {string} customerId The customer id.
         * @param {string} projectId The project id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFromCustomerById: async (storeId: string, customerId: string, projectId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('projectFromCustomerById', 'storeId', storeId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('projectFromCustomerById', 'customerId', customerId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectFromCustomerById', 'projectId', projectId)
            const localVarPath = `/store/{storeId}/project/{customerId}/projects/{projectId}/listProjectAttachedToCustomerById`
                .replace(`{${"storeId"}}`, String(storeId))
                .replace(`{${"customerId"}}`, String(customerId))
                .replace(`{${"projectId"}}`, String(projectId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsFromCustomerByIdApi - functional programming interface
 * @export
 */
export const ProjectsFromCustomerByIdApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsFromCustomerByIdApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get details of a specific project attached to a customer by its ID
         * @param {string} storeId The store identifier.
         * @param {string} customerId The customer id.
         * @param {string} projectId The project id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectFromCustomerById(storeId: string, customerId: string, projectId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCustomerProjectCustomerById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectFromCustomerById(storeId, customerId, projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectsFromCustomerByIdApi - factory interface
 * @export
 */
export const ProjectsFromCustomerByIdApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsFromCustomerByIdApiFp(configuration)
    return {
        /**
         * 
         * @summary Get details of a specific project attached to a customer by its ID
         * @param {string} storeId The store identifier.
         * @param {string} customerId The customer id.
         * @param {string} projectId The project id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFromCustomerById(storeId: string, customerId: string, projectId: string, options?: any): AxiosPromise<ProjectCustomerProjectCustomerById> {
            return localVarFp.projectFromCustomerById(storeId, customerId, projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsFromCustomerByIdApi - object-oriented interface
 * @export
 * @class ProjectsFromCustomerByIdApi
 * @extends {BaseAPI}
 */
export class ProjectsFromCustomerByIdApi extends BaseAPI {
    /**
     * 
     * @summary Get details of a specific project attached to a customer by its ID
     * @param {string} storeId The store identifier.
     * @param {string} customerId The customer id.
     * @param {string} projectId The project id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsFromCustomerByIdApi
     */
    public projectFromCustomerById(storeId: string, customerId: string, projectId: string, options?: any) {
        return ProjectsFromCustomerByIdApiFp(this.configuration).projectFromCustomerById(storeId, customerId, projectId, options).then((request) => request(this.axios, this.basePath));
    }
}
